export default __webpack_public_path__ + "static/7297naval-weapons-5e9669c9979c2856f3fef1f189bdb0aa.jpg";